import apiClient from '@u/apiClient'
import { toTranslatedNamePayload } from '@u/helpers/translatableNames'
import actionsSquareup from '@/store/modules/settings/corporation/site/actions.squareup'
import GetSiteListController from '@/wayfinder/actions/App/Http/Controllers/Site/GetSiteListController'
import GetSiteByIdController from '@/wayfinder/actions/App/Http/Controllers/Site/GetSiteByIdController'
import GetSiteActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Site/GetSiteActivitiesByIdController'
import CreateSiteController from '@/wayfinder/actions/App/Http/Controllers/Site/CreateSiteController'
import DeleteSiteController from '@/wayfinder/actions/App/Http/Controllers/Site/DeleteSiteController'
import DeleteLocationBySiteIdController from '@/wayfinder/actions/App/Http/Controllers/Site/DeleteLocationBySiteIdController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import UpdateSiteController from '@/wayfinder/actions/App/Http/Controllers/Site/UpdateSiteController'

const baseErrors = []

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  ...actionsSquareup,

  // region fetch
  async fetchSiteIndex({ commit }) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(GetSiteListController.get())
      .then(async (response) => {
        await commit('setSiteList', response.data.sites)
        await commit('setSiteMetaData', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchSiteIndex', reason)
      })
  },
  async fetchSiteByID({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(GetSiteByIdController.get({ site: payload.id }))
      .then(async (response) => {
        await commit('setSite', response.data.site)
        await commit('setSiteMetaData', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchSiteByID', reason)
      })
  },
  async fetchNewSite({ commit }) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'site' } }))
      .then(async (response) => {
        await commit('setSite', response.data.site)
        await commit('setSiteMetaData', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewSite', reason)
      })
  },
  fetchSiteActivitiesBySiteID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSiteActivitiesByIdController.get({ site: payload.site_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  async storeNewSite({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })

    let formData = new FormData()

    formData.append(
      'data',
      JSON.stringify(toTranslatedNamePayload(payload.site))
    )

    if (payload.site.new_logo_file) {
      formData.append('new_logo_file', payload.site.new_logo_file)
    }

    await apiClient
      .route(CreateSiteController.post(), formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        if (response.status === 201) {
          commit('auth/setErrors', baseErrors, { root: true })
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('storeNewSite', reason)
      })
  },
  // endregion

  // region update
  async updateSite({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })

    let formData = new FormData()

    formData.append(
      'data',
      JSON.stringify(toTranslatedNamePayload(payload.site))
    )

    if (payload.site.new_logo_file) {
      formData.append('new_logo_file', payload.site.new_logo_file)
    }

    await apiClient
      .formRoute(UpdateSiteController.put({ site: payload.id }), formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        if (response.status === 201) {
          commit('auth/setErrors', baseErrors, { root: true })
          processSuccessCallback(payload)
          // router.push({ name: 'settings_list_site_route' })
        }
      })
      .catch((reason) => {
        console.error('updateSite', reason)
      })
  },
  // endregion

  // region delete
  async deleteSiteById({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(DeleteSiteController.delete.delete({ site: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setSiteList', response.data.sites)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteSiteById', reason)
      })
  },
  async deleteLocationBySiteId({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(
        DeleteLocationBySiteIdController.delete.delete({
          site: payload.site_id,
          location: payload.location_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setSite', response.data.site)
          await commit('setSiteMetaData', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteLocationById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteSiteById({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(DeleteSiteController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setSiteList', response.data.sites)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteSiteById', reason)
      })
  },

  async undoDeleteLocationBySiteId({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(
        DeleteLocationBySiteIdController.undo.delete({
          site: payload.site_id,
          location: payload.location_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setSite', response.data.site)
          await commit('setSiteMetaData', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteLocationById', reason)
      })
  }
  // endregion
}
